const validateTO2 = (rule,value,callback) =>{
  if(value>=10000000){
    callback(new Error('请输入10,000,000.00以内的数字！'));
  }else{
    callback();
  }

};
const validateTO3 = (rule,value,callback) =>{
  if(value>=10000){
    callback(new Error('请输入10,000.00以内的数字！'));
  }else{
    callback();
  }
};
export const startOption = {
    column: [

        {
            type: 'select',
            label: '服务地点',
            span: 24,
            display: true,
            formslot:true,
            prop: 'areaId',

            required: true,
            rules: [
              {
                required: true,
                message: '请选择服务地点'
              },
            ]
          },
          {
            label: "预计完成时间",
            prop: "estimateEndTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            span: 24,
            rules: [
              {
                required: false,
                message: '请选择预计完成时间'
              },
              { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
            ]
          },
      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        formslot:true,
        prop: 'remark',

        required: true,
        rules: [
          {
            required: true,
            message: '请填写备注'
          },
          { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
        ]
      },

      {
        type: 'upload',
        label: '附件',
        span: 24,
        display: true,
        showFileList: true,
        multiple: true,
        limit: 10,
        dataType:'array',
        propsHttp: {},
        canvasOption: {},
        prop: 'attachList',
        formslot:true,
        drag: true,

      }
    ],
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,

    menuPosition: 'right',
    detail: false,
    tabs: false
  }

export const endOption = {
    labelPosition: 'right',
      labelSuffix: '：',
      labelWidth: 120,
      gutter: 0,
      menuBtn: true,
      submitBtn: true,
      submitText: '保 存',
      emptyBtn: false,
      emptyText: '清空',
      menuPosition: 'center',
      detail: false,
      tabs: false,
      column: [
        {
          type: 'select',
          label: '设置协同人',
          span: 24,
          dicData:[],
          display: true,
          disabled:true,
          props:{
            label:'namePhone',
            value:"id"
          },
          prop: 'cooperateLists',
          multiple: true,
          rules:[{required:true,message:'请选择协同人'}]
        },
        {
          type: 'textarea',
          label: '备注',
          span: 24,
          display: true,
          formslot:true,
          prop: 'remark',
          rules: [

            { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
          ]
        },
        {
          type: 'number',
          label: '服务工时',
          span: 12,
          display: true,
          prop: 'workTime',
          rules:[
            { type: 'string',trigger: 'change', validator:validateTO3},
          ],
          formslot:true,
          controls: true,
          value:'0',

        },
        {
          type: 'upload',
          label: '附件',
          span: 24,
          display: true,
          showFileList: true,
          multiple: true,
          limit: 10,
          dataType:'array',
          propsHttp: {},
          canvasOption: {},
          prop: 'attachList',
          formslot:true,
          drag: true,

        }

      ],
    }

// 派单
    export const sendSingleOption = {
      labelPosition: 'right',
        labelSuffix: '：',
        labelWidth: 120,
        gutter: 0,
        menuBtn: true,
        submitBtn: true,
        submitText: '保 存',
        emptyBtn: false,
        emptyText: '清空',
        menuPosition: 'right',
        detail: false,
        tabs: false,
        column: [
          {
            type: 'input',
            label: '工单子类型',
            span: 12,
            display: true,
            disabled:true,
            prop: 'submodelName',

          },
          {
            type: 'select',
            label: '服务班组',
            span: 12,
            disabled:false,
            props:{
              label:'groupName',
              value:"id"
            },
            dicData:[],
            prop: 'subModuleId',
          },
          {
            type: 'select',
            label: '转派人员',
            span: 24,
            dicData:[],
            display: true,
            disabled:false,
            props:{
              label:'namePhone',
              value:"id"
            },
            formslot:true,
            prop: 'handerId',
            required:true,
            rules:[{required:true,message:'请选择转派人员',trigger:'blur'}]
          },
          {
            type: 'textarea',
            label: '备注',
            span: 24,
            display: true,
            formslot:true,
            prop: 'remark',

            rules: [
              {
                required: false,
                message: "备注不能为空",
                trigger: "blur"
              },
              { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
            ]
          },


        ],
      }
// 抢单
export const grabSingleOption = {
  labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    detail: false,
    tabs: false,
    menuPosition:"right",
    column: [

      {
        type: 'datetime',
        label: '期望到场时间',
        span: 24,
        display: true,
        formslot:true,
        prop: 'expectStartTime',

        
      },
      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        formslot:true,
        prop: 'remark',

        rules: [
          {
            required: false,
            message: "备注不能为空",
            trigger: "blur"
          },
          { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
        ]
      },


    ],
  }
// 取 消
export const cencelOption = {
  labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    detail: false,
    tabs: false,
    menuPosition:"right",
    column: [
      {
        type: 'textarea',
        label: '取消原因',
        span: 24,
        display: true,
        formslot: true,
        prop: 'remark',
        required: true,
        rules: [
          {
            required: true,
            message: '请填写备注'
          },
          { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
        ]

      },
      {
        type: 'upload',
        label: '附件',
        span: 24,
        display: true,
        showFileList: true,
        multiple: true,
        limit: 10,
        propsHttp: {},
        canvasOption: {},
        prop: 'attachList',
        fileSize: 500,
        formslot: true,

        drag: true,

      }
    ],
  }
// 报废
export const scrapOption = {
  labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    detail: false,
    tabs: false,
    menuPosition:"right",
    column: [
      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        formslot: true,
        prop: 'remark',
        rules: [{ required: true, message: '请输入备注' }, { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
      },
      {
        type: 'input',
        label: '附件',
        span: 24,
        display: true,
        formslot: true,
        prop: 'attachList',


      }
    ],
  }

  // 接收
export const receiveOption = {
  labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    detail: false,
    tabs: false,
    menuPosition:"right",
    column: [
      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        placeholder:"请输入 备注",
        rules: [
          {
            required: true,
            message: '请输入 备注'
          },
          { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
        ],
        formslot: true,
        prop: 'remark',
      }

    ],
  }

  // 延迟、挂起
  export const delayOption = {
    labelPosition: 'right',
      labelSuffix: '：',
      labelWidth: 120,
      gutter: 0,
      menuBtn: true,
      submitBtn: true,
      submitText: '保 存',
      emptyBtn: false,
      emptyText: '清空',
      detail: false,
      tabs: false,
      menuPosition:"right",
      column: [
        {
          type: "datetime",
          label: '挂起截止时间',
          span: 24,
          display: true,
          formslot: true,
          prop: 'delayEndTime',
          rules: [{ required: false, message: '请选择挂起截止时间' }, {trigger: 'change' }]
        },
        {
          type: 'textarea',
          label: '备注',
          span: 24,
          display: true,
          formslot: true,
          prop: 'remark',
          rules: [{ required: true, message: '请输入备注' }, { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
        },
        {
          type: 'input',
          label: '附件',
          span: 24,
          display: true,
          formslot: true,
          prop: 'attachList',



        }

      ],
    }
// 恢复
export const recoverOption = {
  labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: true,
    submitText: '保 存',
    emptyBtn: false,
    emptyText: '清空',
    detail: false,
    tabs: false,
    menuPosition:"right",
    column: [
      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        formslot: true,
        prop: 'remark',
        rules: [{ required: true, message: '请输入备注' }, { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
      },

    ],
  }

//   评价表单配置

export const evaluateOption = {
  column: [


    {
      type: 'textarea',
      label: '评价内容',
      span: 24,
      display: true,
      rules: [
        { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      ],
      prop: 'content'
    },
    {
      type: 'upload',
      label: '附件',
      span: 24,
      display: true,
      showFileList: true,
      multiple: true,
      limit: 10,
      propsHttp: {},
      canvasOption: {},
      prop: 'attachList',
      fileSize: 500,
      formslot: true,

      drag: true,

    }

  ],
  columnCopy: [


    {
      type: 'textarea',
      label: '评价内容',
      span: 24,
      display: true,
      rules: [
        { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      ],
      prop: 'remark'
    },
    {
      type: 'upload',
      label: '附件',
      span: 24,
      display: true,
      showFileList: true,
      multiple: true,
      limit: 10,
      propsHttp: {},
      canvasOption: {},
      prop: 'attachList',
      fileSize: 500,
      formslot: true,

      drag: true,

    }

  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: false,
  submitText: '保 存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false
}